/**
 * Price display for the admin portal (Products, Coupons). Amounts
 * are always integer paise, never a float (architecture §3/§6) — this is
 * the one place in the admin portal that converts paise → rupees for display,
 * used everywhere a price is shown so the raw-paise-as-rupees bug found in
 * the Users module's `RefundPaymentModal.tsx` is not repeated here.
 */
export function formatPrice(amountInPaise: number, currency: string = 'INR'): string {
  const major = amountInPaise / 100;
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(major);
  } catch {
    return `${currency} ${major.toLocaleString()}`;
  }
}
